import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { TextField, Button, Box, Typography, Container, Paper } from '@mui/material'
import { ExplanationSection } from './ExplanationSection'

export const SessionInput = () => {
  const [sessionId, setSessionId] = useState('')
  const navigate = useNavigate()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (sessionId.trim()) {
      navigate(`/view/${sessionId}`)
    }
  }

  return (
    <Box sx={{ 
      minHeight: '100vh',
      bgcolor: '#FAFBFC',
      backgroundImage: 'radial-gradient(#E2E8F0 1px, transparent 1px)',
      backgroundSize: '24px 24px',
      pt: { xs: 4, md: 6 },
      pb: 8
    }}>
      <Container maxWidth="md" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* Header */}
        <Typography 
          variant="h4" 
          component="h1" 
          sx={{ 
            color: '#1E2A3B',
            mb: { xs: 4, md: 6 },
            textAlign: 'center',
            fontWeight: 600,
            fontSize: { xs: '1.75rem', md: '2rem' }
          }}
        >
          WhatsApp Images to PDF
        </Typography>

        {/* Main Content */}
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 6 }}>
          <ExplanationSection />

          {/* Session Input */}
          <Paper
            component="form"
            onSubmit={handleSubmit}
            elevation={0}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
              p: 4,
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'grey.200',
              bgcolor: 'white',
              maxWidth: '400px',
              mx: 'auto',
              width: '100%'
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#1E2A3B',
                  fontWeight: 600,
                  mb: 1
                }}
              >
                Have a session ID?
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'text.secondary',
                  maxWidth: '280px',
                  mx: 'auto'
                }}
              >
                Enter your session ID to access your WhatsApp images
              </Typography>
            </Box>

            <TextField
              fullWidth
              label="Session ID"
              value={sessionId}
              onChange={(e) => setSessionId(e.target.value)}
              variant="outlined"
              size="medium"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F8FAFC',
                  '&:hover fieldset': {
                    borderColor: 'grey.300',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'primary.main',
                  },
                },
              }}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              sx={{
                bgcolor: 'primary.main',
                py: 1.5,
                fontSize: '0.9375rem',
                fontWeight: 500,
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none',
                  bgcolor: 'primary.dark'
                }
              }}
            >
              Continue
            </Button>
          </Paper>
        </Box>
      </Container>
    </Box>
  )
} 